import Controller from "./privateBusRequest.controller";
import template from "./privateBusRequest.html";

const privateBusRequest = {
  template,
  controller: Controller,
};

export default privateBusRequest;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequest/privateBusRequest.component.js